window.process = window.process || { env: { NODE_ENV: process.env.NODE_ENV } };

const _consoleError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('Invalid DOM property')) return;
  _consoleError(...args);
};

import React, { Suspense } from "react";

import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";

import { Provider } from "react-redux";
import store from './redux/store'

import "./assets/icons/remixicon.css";
import "./assets/less/yoda-theme.less";
import "./assets/style.css";

import App from "./App";

ReactDOM.render(
  <Suspense fallback="loading">
    <Provider store={store}>
      <BrowserRouter >
        <App />
      </BrowserRouter>
    </Provider>
  </Suspense>,
  document.getElementById("root")
);